import { useOrganizerImageSearchQuery } from './gql';

// do not invoke directly.  this is for passing to CloudinaryPhotoInput or CloudinaryPhotoPicker

export function courseImageSearch() {
  return useOrganizerImageSearchQuery({variables:{folder:'course-images'}})[0].data?.imageSearch;
}